import { useTranslation } from 'react-i18next'

import { Tag } from '@/components/ui/Tag'
import type { PaymentStatus } from '@/types/domain'

/* «не подтверждён», or nothing at all (migration 0059, spec L3/L4).
 *
 * Its own file rather than an export beside `PaymentAllocations`, because three
 * surfaces render it — the case's payment rows, the allocation block, the
 * cross-case log — and the first of those mocks `PaymentAllocations` wholesale
 * in its tests. A badge that could only be reached through a component somebody
 * stubs is a badge no test of the row can assert.
 *
 * A CONFIRMED payment carries no badge, and that is the point: it is the
 * ordinary state, and a list where every row wears a label has no signal left
 * in it.
 *
 * The tone is `attention`, never negative, and nothing beside it is struck
 * through or greyed. A pending payment counts in «Оплачено», in the balances
 * and in the aging exactly like a confirmed one (L4) — what is unfinished is
 * the checking, not the money — and a badge that read as a warning is how
 * somebody comes to pay a carrier twice.
 */
export function PaymentStatusTag({ status }: { status: PaymentStatus }) {
  const { t } = useTranslation()
  if (status !== 'pending') return null
  return <Tag tone="attention">{t('finance.payments.pendingTag')}</Tag>
}
